import React, { Component } from 'react'
import { companyVisibility } from '../../../../store/actions/companyActions';
import { connect } from 'react-redux'
class companyVisibileModal extends Component {

    /// README: CALLING CLOUD FUNCTION FOR COMPANY VISIBILITY.


    companyVisibility = () => {
      const { userData, companyData } = this.props;
        const { visibility } = companyData;
        // console.log(userData,visibility)
        this.props.companyVisibility(userData, companyData, !visibility);

    }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle } = this.props;
        const { companyData } = this.props;
        const { visibility } = companyData;
        const visibilityCheck = visibility ? <div className="btn btn-warning btn-md" style={{ float: "right" }} onClick={() => { this.companyVisibility() }}>invisible</div> : <div className="btn btn-warning btn-sm" style={{ float: "right" }} onClick={() => { this.companyVisibility() }}>visibile</div>;
        return (
            <div className="dynamicModalContainer">
            <div className="dynamicModalSm">
                <div className="px-3">
                <p style={modalTitleStyle}>Must read this before proceeding:</p>
                <p style={modalInfoTextStyle}>* By setting visibility to 'invisible', nobody will be able to find your company via search.</p>
                <p style={modalInfoTextStyle}>* However, you can provide QR code of your company so people can send company join request to you.
                      By setting visibility to 'visible', everyone will be able to find your company via search.</p>
                <br />
                {visibilityCheck}
            </div>
            </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        floor: state.floor,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        company: state.company,
        
        userId: state.firebase.auth.uid,
        companyBriefingsData: state.firestore.data.CompanyBriefings,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        companyVisibility: (userModelJson, companyModelJson, newVisibility) => dispatch(companyVisibility(userModelJson, companyModelJson, newVisibility)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(companyVisibileModal)
